import { createSvgIcon } from '@mui/material';

// Білки. Макет 16×16, масштабовано до сітки MUI 24×24.
export const ProteinIcon = createSvgIcon(
  <g transform="scale(1.5) translate(1 2)">
    <circle cx="7.018" cy="2.807" r="2.057" fill="none" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="10.526" cy="9.123" r="2.807" />
    <circle cx="2.807" cy="9.123" r="2.057" fill="none" stroke="currentColor" strokeWidth="1.5" />
  </g>,
  'Protein',
);
